'use client';

// Re-export from the Supabase-powered AuthContext
export { AuthProvider, useAuth } from '@/contexts/AuthContext';
